import React from 'react';
import styled, { keyframes } from 'styled-components';

// Componentes existentes del proyecto
import Menu from '../../../components/Menu/Navbar';
import Header from '../../../components/Header/header';
import Logo from '../../../components/Logo/logo';
import Footer from '../../../components/Footer/footer';
import FxView from '../../../components/FxView/fxview';

// Estilos compartidos (ajusta el path si tu proyecto lo requiere)
import { ContainerGeneral } from '../../RioGrande/styletexto';

// Backend de subida/galería (el clon que creamos)
import LigaBhcDatos from '../../../components/-FireStoreBackend/ligabhc';

// Animación que usas en ContainerTexto
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const Titulo = styled.h1`
  font-family: 'GarnetLight';
  font-weight: bold;
  margin: 10px 0;
  margin-top: 50px;
  text-align: left;
  color: #a0f000;
  font-size: 24px;
`;

export const ContainerTexto = styled.div`
  text-align: left;
  margin: 20px 0;
  animation: ${fadeIn} 2s ease-in-out;
  animation-fill-mode: forwards; /* Mantener estado final */
  opacity: 0; /* Inicial opaco para que la animación haga efecto */
`;

const LigaBhcQ = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <FxView />

      <ContainerGeneral>
        <ContainerTexto>
          <Titulo>LIGA BHC</Titulo>
          <LigaBhcDatos />
        </ContainerTexto>
      </ContainerGeneral>

      <Footer />
    </div>
  );
};

export default LigaBhcQ;
